import React from 'react'
import {Modal} from 'react-bootstrap'
import useBenefitDetailDialogStore from '../../store/benefitDetailDialogStore'

const BenefitDetailMissingModal: React.FC = () => {
  const {isOpen, claimNumber, closeDialog} = useBenefitDetailDialogStore()

  return (
    <Modal
      show={isOpen}
      onHide={closeDialog}
      centered
      animation={false}
      data-testid='benefit-detail-missing-modal'
    >
      <Modal.Header>
        <Modal.Title>Benefit details unavailable</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        We could not load the benefit details for claim {claimNumber}. Please contact support and
        quote this claim number.
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-primary' onClick={closeDialog}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export {BenefitDetailMissingModal}
